import React, { Component } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

library.add(faSearch)


export class Input extends Component {
  state = {
    searchBox: ''
  }

  searchHandler = (val) => {
    this.setState({ searchBox: val.target.value })
  }
  render() {

    return (
      <div style={styles.inputContainer}>

        <input
          style={styles.placeInput}
          placeholder={this.props.placeholder}
          onChange={this.searchHandler}
        />
          

        <button onClick={() => this.props.search(this.state.searchBox)}
          style={styles.placeButton}>
            <FontAwesomeIcon icon="search" />
        </button>

      </div>
    )
  }

}
const styles = {
  inputContainer: {
      display:"flex",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#aaa",
    alignContent: 'center',
    height: 50,
    paddingTop: 5,
    marginTop:-7,
  
  },
  placeButton: {
    width: "15%",
    paddingLeft: 10
  },
  placeInput: {
    width: "70%",
    backgroundColor: 'white',
    height: 40,
    border:'solid',
    borderColor:'#eee',
    borderRadius: 20,
    outline: 'none',
    paddingLeft:10,

  }
}



export default Input